import { COLOR_OPTIONS } from 'config/style';
import type { RiskMapClusterCounts } from '@features/regional-overview/components/risk-map-cluster';
import type { RiskLevel } from '../../domain';

export const getRiskColor = (riskLevel: RiskLevel): string => {
  switch (riskLevel) {
    case 'high':
      return COLOR_OPTIONS.RED_60;
    case 'medium':
      return COLOR_OPTIONS.YELLOW_60;
    case 'low':
      return COLOR_OPTIONS.GREEN_60;
    case 'not_applicable':
    case 'no_threshold':
    default:
      return COLOR_OPTIONS.NEUTRAL_60;
  }
};

export const toRiskMapClusterCounts = (riskCounts: Record<string, number>): RiskMapClusterCounts => {
  const notApplicable = (riskCounts['not_applicable'] ?? 0) + (riskCounts['no_threshold'] ?? 0);
  return {
    high: riskCounts['high'] ?? 0,
    medium: riskCounts['medium'] ?? 0,
    low: riskCounts['low'] ?? 0,
    notApplicable
  };
};

export const createTrapMarkerHTML = (count: number | string, color: string): HTMLElement => {
  const circleSize = 44;
  const pointerWidth = 14;
  const pointerHeight = 12;
  const totalWidth = circleSize;
  const totalHeight = circleSize + pointerHeight;

  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('width', `${totalWidth}`);
  svg.setAttribute('height', `${totalHeight}`);
  svg.setAttribute('viewBox', `0 0 ${totalWidth} ${totalHeight}`);

  const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  circle.setAttribute('cx', `${totalWidth / 2}`);
  circle.setAttribute('cy', `${circleSize / 2}`);
  circle.setAttribute('r', `${(circleSize - 6) / 2}`);
  circle.setAttribute('fill', color);
  circle.setAttribute('stroke', 'white');
  circle.setAttribute('stroke-width', '3');
  svg.appendChild(circle);

  const pointer = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  const pointX = totalWidth / 2;
  const pointY = totalHeight;
  const leftX = pointX - pointerWidth / 2;
  const rightX = pointX + pointerWidth / 2;
  const topY = circleSize - 4;

  pointer.setAttribute('d', `M${leftX},${topY} L${pointX},${pointY} L${rightX},${topY} Z`);
  pointer.setAttribute('fill', 'white');
  svg.appendChild(pointer);

  const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
  text.setAttribute('x', `${totalWidth / 2}`);
  text.setAttribute('y', `${circleSize / 2}`);
  text.setAttribute('text-anchor', 'middle');
  text.setAttribute('dominant-baseline', 'central');
  text.setAttribute('fill', 'white');
  text.setAttribute('font-weight', 'bold');
  text.setAttribute('font-size', '18px');
  text.textContent = count.toString();
  svg.appendChild(text);

  const wrapper = document.createElement('div');
  wrapper.style.position = 'relative';
  wrapper.appendChild(svg);

  return wrapper.firstChild as HTMLElement;
};
